module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/venetian-blind-window/texture.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/venetian-blind-window/texture.png
// module id = 496
// module chunks = 0